import { useState } from 'react';
import { useGetApiRequests, triggerNotification } from '../../../common/CommonExport';
import { Employee, EmployeeKpiData, ApiError } from '../types';

interface UseViewKpiProps {
    monthYear: string;
}

export const useViewKpi = ({ monthYear }: UseViewKpiProps) => {
    const [isViewKpiModalOpen, setIsViewKpiModalOpen] = useState(false);
    const [selectedEmployee, setSelectedEmployee] = useState<Employee | null>(null);
    const [viewKpiData, setViewKpiData] = useState<EmployeeKpiData[]>([]);
    const [modalLoading, setModalLoading] = useState(false);

    const getEmployeeKpiDetailsApi = useGetApiRequests('employeeKpiDetail', 'GET');

    const fetchEmployeeKpiDetails = async (employeeId: number) => {
        setModalLoading(true);
        try {
            const queryParams = { monthYear: monthYear };
            const pathParams = { id: employeeId }
            const response = await getEmployeeKpiDetailsApi(null, queryParams, pathParams);
            if (response && 'data' in response && response.data.status.success === 'Success') {
                setViewKpiData(response.data.data || []);
            } else {
                setViewKpiData([]);
                const errorMsg = (response as ApiError)?.data?.status?.message || "No KPI data found.";
                triggerNotification('warning', errorMsg, "", "topRight");
            }
        } catch (error) {
            console.error("Failed to fetch Employee KPI Details", error);
            const err = error as ApiError;
            const errorMessage = err.response?.data?.status?.message || err.response?.data?.message || err.message || "Failed to fetch KPI details.";
            triggerNotification('error', errorMessage, "", "topRight");
        } finally {
            setModalLoading(false);
        }
    };

    const handleOpenViewKpiModal = (employee: Employee) => {
        setSelectedEmployee(employee);
        setIsViewKpiModalOpen(true);
        fetchEmployeeKpiDetails(employee.employeeId);
    };

    const handleCloseViewKpiModal = () => {
        setIsViewKpiModalOpen(false);
        setSelectedEmployee(null);
        setViewKpiData([]);
    };

    return {
        isViewKpiModalOpen,
        selectedEmployeeView: selectedEmployee,
        viewKpiData,
        handleOpenViewKpiModal,
        handleCloseViewKpiModal,
        modalLoadingView: modalLoading
    };
};
